import { Button } from 'ccs-ui-components';
import { ButtonProps } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import classes from './Header.module.scss';

type Props = { isEditClicked?: boolean } & {
  onAddClicked: () => void;
} & {
  onUpdateClicked?: () => void;
} & {
  onCancelClicked?: () => void;
} & ButtonProps;

const Header = ({ onAddClicked, disabled, isEditClicked = false, onUpdateClicked = () => { }, onCancelClicked = () => { } }: Props) => {
  const { t: translate } = useTranslation();
  return (
    <div className={`${classes['button-container']} ci-button-group`}>
      <Button
        variant="secondary"
        onClick={onCancelClicked}
        data-testid="btn-cancel"
      >
        {translate('service_wrapper_component.lbl_cancel')}
      </Button>
      {!isEditClicked && (
        <Button
          variant="primary"
          className={classes['btn-add']}
          onClick={onAddClicked}
          disabled={disabled}
          data-testid="btn-create"
        >
          {translate('service_wrapper_component.lbl_create')}
        </Button>
      )}
      {isEditClicked && (
        <Button
          variant="primary"
          className={classes['btn-add']}
          onClick={onUpdateClicked}
          disabled={disabled}
          data-testid="btn-update"
        >
          {translate('service_wrapper_component.lbl_update')}
        </Button>
      )}
    </div>
  );
};
export default Header;
